<template>
  <div>
    <Navbar v-if="$route.meta.navbar && mainfield == ''"/>
    <Breadcrumb v-if="$route.meta.navbar && mainfield == ''" />
    <div class="justify-content-between pb-2 px-4">
      <span class="float-end">
          <div class="input-group input-group-sm my-0">
              <input
                  class="form-control"
                  v-model="search"
                  placeholder="Search..."
                  type="text"
                  @input="data_search"
                  autocomplete="off"
              />
              <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="search = ''"
              >
                  X
              </button>
          </div>
      </span>
      <span class="float-end me-2">
        <button class="btn btn-secondary" @click.prevent="excelexport">
          <fa-icon
            name="file-excel"                        
          />
          Export
        </button>
      </span>         
    </div>
    
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th 
              v-for="field in tablefields" 
              :key="field.key"
              @click="field.sortable && data_sort_column(field.key)"
              :style="field.sortable ? 'cursor: pointer;' : ''"
            >
              <div v-if="field.key!='id'&&field.key!='actions'">
                {{ field.label }}
                <span v-if="orderby === field.key">
                  {{ orderdesc ? '▼' : '▲' }}
                </span>
              </div>
              <div v-else>
                {{ field.label }}
              </div>
              <div>
                <span v-if="field.list_filter==1">
                  <input 
                    v-if="field.input_type=='TEXT'"
                    class="form-control form-control-sm"
                    v-model="listfilter[field.field_name]"
                    @change="data_filterget"
                  />
                  <select
                    v-if="field.input_type=='SELECT'"
                    class="form-select form-select-sm"
                    v-model="listfilter[field.field_name]"
                    @change="data_filterget"
                  >
                    <option v-for="opt in field.lookup_options" :key="opt.value" :value="opt.value">
                      {{ opt.text }}
                    </option>
                  </select>
                </span>
                <div 
                  v-if="field.list_filter!=1" 
                  class="gdq-input-placeholder"
                  style="height: 39px"
                >
                  <span style="color: white;">.<br/></span>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="loading || searching">
          <tr>
            <td :colspan="tablefields.length" class="text-center text-success my-2">
              <div class="spinner-border align-middle me-2" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <strong>Loading...</strong>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="record in records" :key="record.id">
            <td v-for="field in tablefields" :key="`${record.id}-${field.key}`">
              <span v-if="field.formatter">{{ field.formatter(record[field.key]) }}</span>
              <span v-else>{{ record[field.key] }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <Pagination
      :current-page="currentPage"
      :per-page="perPage"
      :total-rows="rows"
      aria-label="Report pagination"
      @page-changed="currentPage = $event"
    />
  </div>
</template>
<script>
import _ from 'lodash';
import axios from 'axios'
import { config } from '../../config';
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
import Pagination from './Pagination.vue';
const base_url = config.base_url;
const api_token = config.api_token;

const stripTags = (original) => {
  return original.replace(/(<([^>]+)>)/gi, "");
};

export default {
  name: 'ReportList',
  props: [
    'viewname',
    'mainfield',
    'mainvalue',
    'standalone',    
  ],
  components: {
    Navbar,
    Breadcrumb,
    Pagination,
  },
  data: function() {
    return {
      loading: true,
      written: '',
      screenfields: [],
      tablefields: [],
      records: [],
      filter: {},
      listfilter: [],
      filtersep: 'AND',    
      currentPage: 1,
      perPage: 10,
      rows: 0,
      orderby: 'id',
      orderdesc: false,
      search: '',
      searching: false,
      searchcalc: false,
      filtering: false,
      lookupoptions: [],
      dbfields: [],
    }
  },
  computed: {
  },
  watch: {
    currentPage: function() {
      this.data_get();
    },
    search: function() {
      this.filtering = false
      this.searching = true
      this.data_search()
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.init();
  },
  methods: {
    data_sort_column(column) {
      if (this.orderby === column) {
        this.orderdesc = !this.orderdesc;
      } else {
        this.orderby = column;
        this.orderdesc = false;
      }
      this.currentPage = 1;
      this.data_get();
    },
    async init() {
      await this.$nextTick();
      this.fields_get()
      .then(() => {
        this.data_filterget();
      })
    },
    excelexport() {
      this.loading = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.$store.state.token
      return new Promise(() => {
        axios({
          url: base_url+"/excel/"+this.viewname,
          method: 'POST',
          responseType: 'blob',
          data: { filter: JSON.stringify(this.filter) },
        })
        .then((resp) => {
            var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            var filename = 'Export';
            fileLink.setAttribute("download", filename + ".xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
            this.loading=false;
            this.bulkaction = 0;
        });
      });
    },
    fields_get() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return new Promise((resolve) => {
        axios.get(
          base_url+"/fields/"+this.viewname,
          '', {
              headers: {
                  "Accept": "application/json",
                  "Content-type": "application/json",
              }
          }
        )
        .then(resp => {
          var dbfields = resp.data;

          const f = dbfields.filter(a => a.list_display == 1)
          .map((a) => {
              let tablefield = {
                  key: a.field_name,
                  sortable: true, 
                  label: a.list_caption,
                  tdClass: (a.input_type === 'TEXTAREA' || a.input_type === 'HTML') ?
                      'gdq-chop':
                      a.list_pixels != 0 ?
                          'gdq-w'+a.list_pixels :
                          a.list_filter == 1 ?
                              'gdq-w170':
                              '',
                  thClass: a.list_pixels != 0 ? 'gdq-w'+a.list_pixels : a.list_filter == 1 ? 'gdq-w170':'', 
                  list_filter: a.list_filter,
                  field_name: a.field_name,
                  input_type: a.input_type,
                  lookup_options: a.lookup_options,
                  input_readonly: a.input_readonly,
                  formatter: a.input_type !== 'HTML' ?
                      value => {
                          return value
                      }:
                      value => {
                          return value ? stripTags(value):''
                      },
              }
              return tablefield;
          });
            var r = [
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true,
                    list_filter: 0,
                    isHtml: 0,
                }
            ];
            r.push.apply(r,f)
            r.push({
                key: 'actions',
                label: '',
                list_filter: 0,
                isHtml: 0,
            });
            this.tablefields = r;
            const s = dbfields.filter(
                a => a.key_field != 0)
                .map((a) => {
                    return {
                        orderby: a.field_name,
                        orderdesc: a.key_field == 2?true:false,
                    }
                });
            if (s.length > 0) {
                this.orderby = s[0].orderby;
                this.orderdesc = s[0].orderdesc;
            }
            const g = dbfields.filter(
                a => a.input_type == 'SUBSELECT'
            );
            g.forEach( f => {
                for (var i=0;i<dbfields.length;i++) {
                    if (dbfields[i].field_name == f.control_field) {
                        dbfields[i]['subtable'] = f.lookup_table;
                        dbfields[i]['subfield'] = f.subtable_filter_field;
                    }
                }
                
            });
            dbfields = dbfields.map( f => {
                return {
                    ...f,
                    colspan: 12,
                }
            });
            var start = -1;
            const screenfields = dbfields.filter( f => f.input_type != 'NONE');
            for (var i=0;i<screenfields.length;i++) {
                if (screenfields[i].input_merge_next == 1 && start == -1) {
                    start = i;
                }
                if (screenfields[i].input_merge_next == 0 && start != -1 && i != start) {
                    const colspan = Math.round(12/((i+1)-start));
                    for (var j=start;j<=i;j++) {
                        screenfields[j].colspan = colspan;
                    }
                    start = -1;
                }
            }
            this.dbfields = dbfields;
            this.screenfields = screenfields;
            for (var k=0; k<dbfields.length; k++) {
                if (dbfields[k].list_filter == 1) {
                    this.listfilter[dbfields[k].field_name] = this.dbfields[k].input_default;
                }
            }      
        })
        .then(resp => {
            resolve(resp);
        })
      });
    },
    load_subselects() {
      for (var i=0;i<this.dbfields.length;i++) {
        this.load_subselect(this.dbfields[i]);
      }
    },
    load_subselect(field) {
      if (field.subfield) {
        const table_name = field.subtable;
        const filter = {
          [field.subfield]: {
            operator: '=',
            value: this.record[field.field_name],                 
          }
        };
        const lu = this.dbfields.filter (a => {
            return a.lookup_table == table_name;
        });
        const lookup_field = lu[0].lookup_field;
        const lookup_display = lu[0].lookup_display;
        const lookup_sort = lu[0].lookup_sort;
        axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
        return new Promise((resolve,reject) => {
          axios.get(
            base_url+'/'+table_name+'?'
            +'filter='+JSON.stringify(filter)
            +'&orderby='+lookup_sort
          )
          .then(resp => {
            const records = resp.data.result;
            const v = records.map ((a) => {
              return {
                  value: a[lookup_field],
                  text: a[lookup_field]+' - '+a[lookup_display],
              }
            });
            for (var i=0;i<this.dbfields.length;i++) {
              if (this.dbfields[i].control_field == field.field_name) {
                  this.dbfields[i].lookup_options = v;
              }
            }
            resolve(resp);
          })
          .catch(err => {
              reject(err)
          })
        })                
      }
    },
    data_filterget() {
      if (!this.filtering) {
        const orderby = this.orderby;
        const orderdesc = this.orderdesc;
        this.filtering = true;
        this.searching = false;
        var filter = {};
        const filterfields = this.tablefields.filter((f) => {
          return f.list_filter == "1" && typeof(this.listfilter[f.key]) != 'undefined' && this.listfilter[f.key] != 0
        });
        if (filterfields.length) {
          filterfields.forEach((f) => {
            const filtervalue = this.listfilter[f.key];
            const fieldweneed = this.dbfields.filter((ff) => {
              return ff.field_name == f.key
            });
            const lookupoptions = fieldweneed.map((a) => {
              return a.lookup_options;
            })[0];
            const value = lookupoptions.filter((a) => {
              return a.value == filtervalue;
            });
            const text = value[0].text;
            filter[f.key] = {
              operator: '=',
              value: text,
            }
          });
          this.currentPage = 1;
          this.filtersep = 'AND';
          this.search = "";
        }
        this.filter = filter;
        this.orderby = orderby;
        this.orderdesc = orderdesc;
        this.data_get();
      }           
    },
    data_search: _.debounce(function() {
      this.searchcalc = true
      setTimeout(function() {
          if (this.filtering === false) {
              this.data_searchget();
              this.searchcalc = false;
              this.searching = false;
          }
      }.bind(this),500)
    },300),
    data_searchget() {
      const filterfields = this.tablefields.filter((f) => {
        return f.list_filter == "1" && typeof(this.listfilter[f.key]) != 'undefined'  && this.listfilter[f.key] != 0
      });
      filterfields.map((f) => {
        this.listfilter[f.key] = 0;
      })
      var filter = {};
      if (this.search != "") {
        filter = {};
        for (var i=0;i<this.dbfields.length;i++) {
          if (
            (
              this.dbfields[i].field_type == 'VARCHAR' || 
              this.dbfields[i].field_type == 'TEXT' || 
              this.dbfields[i].input_type == 'SELECT' || 
              this.dbfields[i].input_type == 'SUBSELECT' || 
              this.dbfields[i].input_type == 'NONE' 
            ) && 
            this.dbfields[i].list_display == 1
          ) {
            filter[this.dbfields[i].field_name] = {
              operator: 'LIKE',
              value: '*'+this.search+'*',
            }
          }
        }
      }            
      this.currentPage = 1;
      this.filter = filter;
      this.filtersep = ' OR ';
      this.data_get();
    },
    data_sort(context) {
      this.orderby = context.sortBy;
      this.orderdesc = context.sortDesc;
      this.currentPage = 1;
      this.data_get();
    },
    data_get() {
      var filter = this.filter;
      this.loading = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      const data_get_url = this.viewname;
      const url = base_url+"/"+data_get_url+"?v=1"
        +'&start='+(this.currentPage-1)*this.perPage
        +'&limit='+this.perPage
        +'&orderby='+this.orderby
        +'&order='+(this.orderdesc?"DESC":"ASC")
        +'&filter='+JSON.stringify(filter)
        +'&filtersep='+this.filtersep
        +'&mainfield='+(this.mainfield?this.mainfield:'')
        +'&mainvalue='+(this.mainvalue?this.mainvalue:'')
      return new Promise((resolve) => {
        axios.get(
            url,
            {
                headers: {
                    "Accept": "application/json",
                    "Content-type": "application/json",
                }
            }
        )
        .then(resp => {
          this.records = resp.data.result.map( (a) => { 
            return a; 
          });
          this.rows = resp.data.total;
          this.loading = false;
          this.filtering = false;
          this.searching = false;
          resolve(resp);
        })
      });            
    },
    format_date(date) {
      var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
      if (isNaN(year)) { return ''; }
      if (Number.isNaN(month)) { return ''; }
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    },
    format_time(date) {
      if (date.length == 5) {
          return date;
      }
      var d = new Date(date);
      var h = d.getHours();
      var m = d.getMinutes();
      var hour = (h>9?'':'0')+h;
      var minute = (m>9?'':'0')+m;
      var thistime = hour+':'+minute;
      return thistime;
    },
  }  
}
</script>
<style>
</style>
